import { inviteService } from '@/services/invites.service';

const initialState = () => ({
  status: {
    error: null,
    pending: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  resendEmail({ commit }, token) {
    commit('SEND_EMAIL');
    return inviteService
      .resendEmail(token)
      .then((response) => {
        commit('SUCCESS');
        return response;
      })
      .catch((error) => {
        commit('ERROR', error);
        throw error;
      });
  },
  resendEmailFromLogin({ commit }, email) {
    commit('SEND_EMAIL');
    return inviteService
      .resendEmailFromLogin(email)
      .then((response) => {
        commit('SUCCESS');
        return response;
      })
      .catch((error) => {
        commit('ERROR', error);
        throw error;
      });
  },
};

const mutations = {
  SEND_EMAIL(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  SUCCESS(state) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
  },
  ERROR(state, error) {
    state.status = {
      ...state.status,
      error: error,
      pending: false,
      rejected: true,
    };
  },
};

const getters = {
  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const sendEmailConfirmation = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
